const moduleName = 'knalli.angular-vertxbus';

export {moduleName};



// WEBPACK FOOTER //
// ./src/config.js